import { Injectable } from '@angular/core'
import { UIInfo } from '../models/app-config/ui-info.model'

/**
 * This service will be an abstraction for the access of localstorage, sessionstorage and indexDB (maybe even cookie)
 *
 */
@Injectable({
  providedIn: 'root'
})
export class BrowserStorageService {
  private readonly MASTER_OF_DISASTER_KEY = 'masterOfDisasterRightId'

  // ****************** Settings ****************

  get hasMasterOfDisasterRightId(): boolean {
    return !!localStorage.getItem(this.MASTER_OF_DISASTER_KEY)
  }

  get masterOfDisasterRightId(): number {
    return +localStorage.getItem(this.MASTER_OF_DISASTER_KEY)
  }

  set masterOfDisasterRightId(id: number) {
    localStorage.setItem(this.MASTER_OF_DISASTER_KEY, id + '')
  }

  constructor() {}
}
